import wordsPayload from './words.json';

export class WordListContainer {
  private readonly lookup: string[];

  constructor() {
    // @ts-ignore
    this.lookup = wordsPayload.words;
  }

  getRandomWord(): string | null {
    if (this.lookup.length === 0) {
      return null;
    }

    return this.lookup[Math.floor(Math.random() * this.lookup.length)];
  }
}
